export default __webpack_public_path__ + "static/media/Pot2.6ef28732.svg";